import { Component, Prop, Vue } from 'vue-property-decorator';

import { StepsKeys } from '@/plugins/podolib/services/analysis';

@Component
export default class AnalysisStepper extends Vue {
  @Prop({ required: true }) private readonly currentStepKey!: StepsKeys;

  get _currentStepKey() {
    return this.currentStepKey;
  }

  set _currentStepKey(key: StepsKeys) {
    this.$emit('update:currentStepKey', key);
  }

  /**
   * Manifest entry of "analysis" step
   */
  get stepAnalysis() {
    return this.$pdc.analysis!.getManifestEntry(StepsKeys.Analysis);
  }

  /**
   * Get steps
   */
  get stepsWithLabel() {
    return this.$pdc.analysis!.stepsWithLabel;
  }

  /**
   * Get if is locked
   */
  get lock() {
    return this.$pdc.analysis!.analysisOrComputeInProgress || this.$pdc.analysis!.computeCompleted;
  }

  /**
   * Get the index of the current step
   */
  get currentStepIndex() {
    return Object.values(this.stepsWithLabel.map((x) => x.key)).indexOf(this.currentStepKey);
  }
}
